// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseImage_container__2u9vc","loading":"BaseImage_loading___yw_j","error":"BaseImage_error__ELvw0"};